import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Accordion } from '@gumtree/ui-library';

import Select from '../../filters/select';
import { fetchAbundance } from '../../../get-data/fetch/fetch-abundance';
import { SrpState, SrpUseDispatch } from '../../../reducers';
import { setSingleFilterState, setFilterThunk } from '../../../reducers/current-filter-states';
import { updateSearchResultAbundance } from '../../../reducers/search-result-abundance';
import { EXPANDED_FILTERS, CUSTOM_FILTERS, DEFAULT_FILTER_LABEL } from '../../shared/constants';

import { Container } from './styles';
import { trackFilterOpenChange } from '../../shared/filters-utils';
import { updateFiltersDictionary } from '../../../reducers/filters-dictionary';
import type { FilterData, FiltersDictionary } from '../../../types';

const defaultSelectOption = { label: 'Any', value: '' };

const Make = () => {
    const dispatch = useDispatch() as SrpUseDispatch;

    const {
        resultsPage: { filtersDictionary, currentFilterStates },
        baseConfig: { category },
    } = useSelector((data: SrpState): SrpState => data);

    const makers = filtersDictionary.vehicle_make?.values || [defaultSelectOption];
    const models = filtersDictionary.vehicle_model?.values || [defaultSelectOption];
    const make =
        filtersDictionary.vehicle_make?.values?.find(
            (item) => item.value === currentFilterStates.vehicle_make
        ) || defaultSelectOption;

    const model =
        filtersDictionary.vehicle_model?.values?.find(
            (item) => item.value === currentFilterStates.vehicle_model
        ) || defaultSelectOption;

    const [isModelLoading, setIsModelLoading] = useState<boolean>(false);

    const onMakeChange = (option) => {
        dispatch(updateSearchResultAbundance(option.abundance || 0));
        dispatch(setFilterThunk({ key: CUSTOM_FILTERS.MAKE, value: option.value }));
        setIsModelLoading(true);
        fetchAbundance(
            CUSTOM_FILTERS.MODEL,
            {
                ...currentFilterStates,
                [CUSTOM_FILTERS.MAKE]: option.value,
            },
            (data: FilterData) => {
                dispatch(
                    setSingleFilterState({
                        key: CUSTOM_FILTERS.MODEL,
                        value: data.values[0].value,
                    })
                );
                dispatch(
                    updateFiltersDictionary(
                        {
                            [CUSTOM_FILTERS.MODEL]: data,
                        } as FiltersDictionary,
                        category
                    )
                );
                setIsModelLoading(false);
            },
            (error) => {
                setIsModelLoading(false);
                 
                console.error(error);
            }
        );
    };

    const onModelChange = (option) => {
        dispatch(updateSearchResultAbundance(option.abundance || 0));
        dispatch(setFilterThunk({ key: CUSTOM_FILTERS.MODEL, value: option.value }));
    };

    const handleAccordionOpenChange = (open: boolean) => {
        trackFilterOpenChange(open, CUSTOM_FILTERS.MAKE);
    };

    return (
        <Accordion
            title="Make & Model"
            isDefaultOpened={EXPANDED_FILTERS.includes(CUSTOM_FILTERS.MAKE)}
            onOpenChange={handleAccordionOpenChange}
        >
            <Container>
                <Select
                    id="filter-vehicle-make"
                    label="Make"
                    value={make}
                    options={makers}
                    onChange={onMakeChange}
                />
                <Select
                    id="filter-vehicle-model"
                    label="Model"
                    value={model}
                    options={models}
                    onChange={onModelChange}
                    isDisabled={make.label === DEFAULT_FILTER_LABEL || isModelLoading}
                    isLoading={isModelLoading}
                />
            </Container>
        </Accordion>
    );
};

export default Make;
